import { Stack, Typography } from '@mui/material';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const TextDetailsTuple = ({
  primaryProp,
  secondaryProp,
}: {
  primaryProp?: string;
  secondaryProp?: string;
}) => {
  return (
    <Stack gap='4px' overflow='hidden'>
      {primaryProp && <OverflowTooltip text={primaryProp} />}
      {secondaryProp && primaryProp !== secondaryProp && (
        <OverflowTooltip
          text={secondaryProp}
          renderContent={(text, ref) => (
            <Typography
              ref={ref}
              variant={primaryProp ? 'body2' : 'subtitle1'}
              color={
                primaryProp
                  ? 'var(--mui-palette-text-secondary) !important'
                  : 'text.primary'
              }
              className='truncate'
            >
              {text}
            </Typography>
          )}
        />
      )}
    </Stack>
  );
};
